const getWording = () => {
    let wording = localStorage.getItem('wording') ?? '{}'
    wording = JSON.parse(wording)
    return wording;
}

export default getWording;